<template>
  <div>
    <div class="layout-wrapper" v-if="sessionLevel >= 20">
      <div class="content-wrapper">
        <Header></Header>
        <div class="content-body" style="margin-top: 0px !important;">
          <RouterView></RouterView>
        </div>
      </div>
      <Footer></Footer>
    </div>
    <Login v-else></Login>
  </div>
</template>

<script>
import Header from "./components/Common/Header";
import Footer from "./components/Common/Footer";
import Login from "./components/Common/Login";
import session from "./store/session";

export default {
  name: 'App',
  components: {
    Login,
    Footer,
    Header,
  },
  computed: {
    sessionLevel () {
      let level = session.state.session.sessionLevel;
      return level
    }
  },
  mounted: function () {
      console.log('General management frontend - version ' + process.env.VUE_APP_VERSION_NUMBER + ' build ' + process.env.VUE_APP_VERSION_TIME + '.')
      console.log('Identity backend: ' + process.env.VUE_APP_IDENTITY_BACKEND_URL)
    this.$store.dispatch('checkSession')
  }
}
</script>

<style>
  .content-body {
    margin-top: 75px;
  }
</style>
